import { render, staticRenderFns } from "./tqm.vue?vue&type=template&id=ca98ee26&scoped=true&"
import script from "./tqm.vue?vue&type=script&lang=js&"
export * from "./tqm.vue?vue&type=script&lang=js&"
import style0 from "./tqm.vue?vue&type=style&index=0&id=ca98ee26&scoped=true&lang=css&"
import style1 from "./tqm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca98ee26",
  null
  
)

export default component.exports